#### `CandidateProfile.associatedPositionProfile` field

When retrieving a candidate profile from the SEEK API,
you typically need to select additional fields to attribute it to a position and hirer.
Previously, this required indirection through the [`CandidateProfile.associatedPositionOpenings`] field,
which was generally unintuitive and inefficiently retrieved all position profiles for the opening.

The new [`CandidateProfile.associatedPositionProfile`] field allows you to directly select the position associated with a candidate application or profile purchase:

```diff
    query ($id: String!) {
      candidateProfile(id: $id) {
+       associatedPositionProfile {
-       associatedPositionOpenings {
-         positionOpening {
-           positionProfiles {
              seekHirerJobReference
              positionOrganizations {
                id {
                  value
                }
              }
-             positionUri
-           }
-         }
-         positionUri
        }
      }
    }
```

[`candidateprofile.associatedpositionopenings`]: /schema/named-type/CandidateProfile#/field/associatedPositionOpenings
[`candidateprofile.associatedpositionprofile`]: /schema/named-type/CandidateProfile#/field/associatedPositionProfile
